module.exports = __webpack_public_path__ + "static/media/logo.5d7bf0c8.png";